import { useEffect } from 'react';
import { scrollToHash, getHeaderHeight } from '../utils/scrollToHash';

// MUI sm breakpoint (600px)
const SM_BREAKPOINT = 600;

/**
 * 페이지 초기 로드 시 URL 해시가 있으면 해당 요소로 스크롤하는 훅
 * - 초기 로드 시에만 실행 (링크 클릭은 SmoothLink에서 처리)
 * - 헤더 높이를 고려하여 오프셋 적용
 */
const useHashScroll = () => {
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;

    // DOM 렌더링 대기
    const timeoutId = setTimeout(() => {
      const elementId = hash.replace('#', '');
      // Calculate isXs at execution time to avoid stale closure
      const isXs = window.innerWidth < SM_BREAKPOINT;
      scrollToHash(elementId, getHeaderHeight(isXs));
    }, 100);

    return () => clearTimeout(timeoutId);
  }, []); // 초기 로드 시에만 실행
};

export default useHashScroll;
